import type { FBSContainerListResponse } from "@/shared/generated/ExpHubApi";
import { ContractType } from "./ContractType";

export interface Meter {
  number: string;
  contractId: string;
  // This internal customer ID is used in order requests of a single meter customer
  internalCustomerId?: string;
  // contains contractId of corresponding gas container
  gasContainerContractId?: string;
}

export const mapToMeterType = (
  container: FBSContainerListResponse["containers"][number],
): Meter => {
  if (container.contract?.type !== ContractType.MeterContract) {
    throw new Error(`Expected ZVZ contract, got: ${container.contract?.type}`);
  }

  return {
    number: container.meterNumber ?? "",
    contractId: container.contractId,
    internalCustomerId: container.customer?.internalCustomerZS,
    gasContainerContractId: container.correspondingContractId,
  };
};
